import { render, staticRenderFns } from "./InspectorMain.vue?vue&type=template&id=c159810c&scoped=true&"
import script from "./InspectorMain.vue?vue&type=script&setup=true&lang=js&"
export * from "./InspectorMain.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./InspectorMain.vue?vue&type=style&index=0&id=c159810c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c159810c",
  null
  
)

export default component.exports